export const twitterPixelTracking = (pixelID: string, type: string): void => {
  window.twq('init', pixelID)
  window.twq('track', type)
}
